<template lang="pug">
  .component-client-registration
    .row
      .small-12.large-6.columns
        label
          | Name
          input(type='text', placeholder='', :value="body.name.toUpperCase()" @input="body.name = $event.target.value.toUpperCase()")
      .small-12.large-6.columns
        label
          | Description
          input(type='text', placeholder='', v-model='body.description')
    .row
      .columns.text-right
        button.button(@click="formSubmit") Create
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  export default {
    name: "BackofficeCreateVehicleType",
    components: {
    },
    data() {
      return {
        vehicleBrands: [],
        showFileSelector: false,
        body: {
          name: '',
          description: '',
        }
      }
    },
    methods: {
      formSubmit() {
        KeplerBackofficeSdk.vehicleTypes.make(this.body, () => {
          this.$router.push({name: 'types'})
        })
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateVehicleType.vue?768cd7e6